import productService from "./productService";
import {
  sendOutwardProductsLikeClassic,
  validatePlaceSettings,
  formatApiError,
} from "../utils/adminBulkSendHelpers";
import { filterSendableProducts } from "../utils/sendProductBulkFilters";

export function parseCategoryProductsResult(
  result,
  maxTotalCount,
  page = 1,
  pageSize = 100
) {
  const products = Array.isArray(result?.data)
    ? result.data
    : Array.isArray(result)
    ? result
    : [];

  const rawTotal =
    Number(result?.recordsTotal) ||
    Number(result?.RecordsTotal) ||
    Number(result?.recordsFiltered) ||
    Number(result?.RecordsFiltered) ||
    Number(result?.total) ||
    Number(result?.Total) ||
    0;

  let listTotal;
  if (rawTotal > 0) {
    listTotal = Math.min(rawTotal, maxTotalCount);
  } else {
    const pageItems = products.length;
    if (pageItems < pageSize) {
      listTotal = Math.min((page - 1) * pageSize + pageItems, maxTotalCount);
    } else {
      // Dolu sayfa ama toplam yok — kullanıcının üst limitiyle sayfala
      listTotal = maxTotalCount;
    }
  }

  return { products, listTotal, rawTotal };
}

const bulkAutoSendService = {
  /**
   * Eski mod: productService.getCategoryProducts (aynı parametreler)
   */
  fetchProductsPage: async ({
    userId,
    page,
    pageSize,
    marketPlaceId,
    ecommercePlaceId,
    categoryId,
    containsTitle = "",
    maxTotalCount = Number.MAX_SAFE_INTEGER,
  }) => {
    const result = await productService.getCategoryProducts(
      categoryId,
      userId,
      page,
      marketPlaceId,
      ecommercePlaceId,
      pageSize,
      containsTitle
    );

    const parsed = parseCategoryProductsResult(
      result,
      maxTotalCount,
      page,
      pageSize
    );
    return {
      products: parsed.products,
      recordsTotal: parsed.rawTotal || parsed.listTotal,
      listTotal: parsed.listTotal,
    };
  },

  validatePlaceSettings,

  sendProductIds: async (params) => {
    return sendOutwardProductsLikeClassic(params);
  },

  /** Filtreye uyan tüm sayfalardan seçilebilir ürün id'leri (üst limit dahil) */
  fetchAllSendableProductIds: async ({
    userId,
    pageSize,
    marketPlaceId,
    ecommercePlaceId,
    categoryId,
    containsTitle = "",
    maxTotalCount,
    onProgress,
  }) => {
    const limit = Math.max(1, Number(maxTotalCount) || 1);
    const size = Math.max(1, Number(pageSize) || 10);
    const ids = [];
    let page = 1;
    let totalPages = 1;

    const report = (percent, statusText) => {
      onProgress?.({
        percent: Math.min(100, Math.max(0, Math.round(percent))),
        statusText,
        selectedCount: ids.length,
        currentPage: page,
        totalPages,
      });
    };

    report(0, "Seçilebilir ürünler taranıyor…");

    while (ids.length < limit) {
      const { products, listTotal } = await bulkAutoSendService.fetchProductsPage(
        {
          userId,
          page,
          pageSize: size,
          marketPlaceId,
          ecommercePlaceId,
          categoryId,
          containsTitle,
          maxTotalCount: limit,
        }
      );

      if (page === 1) {
        totalPages = Math.max(1, Math.ceil(listTotal / size));
      }

      if (!products?.length) break;

      for (const product of filterSendableProducts(products)) {
        if (ids.length >= limit) break;
        ids.push(product.id);
      }

      const pagePercent = Math.round((page / totalPages) * 90);
      report(
        pagePercent,
        totalPages > 1
          ? `Sayfa ${page} / ${totalPages} taranıyor…`
          : "Seçilebilir ürünler kontrol ediliyor…"
      );

      const reachedEnd =
        products.length < size || page * size >= listTotal;
      if (reachedEnd) break;

      page += 1;
    }

    const result = ids.slice(0, limit);
    report(100, "Seçim tamamlandı");
    return result;
  },

  formatApiError,
};

export default bulkAutoSendService;
